function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\u77E9\u5F62");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5207\\u56FE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u5185\\u5BB9\\u7BA1\\u7406-\\u60AC\\u505C\\u5C55\\u793A",
  transform: "translate(-32.000000, -605.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u6E20\\u9053\\u7BA1\\u7406",
  transform: "translate(32.000000, 605.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.0619333,11.9992 L13.9372667,11.9992 L13.9372667,10.5618667 L6.06226667,10.5618667 L6.06226667,11.9992 L4.9376,11.9992 L4.9376,10.5618667 C4.9376,9.9412 5.4416,9.4372 6.06226667,9.4372 L9.43626667,9.4372 L9.43626667,7.99986667 L10.5632667,7.99986667 L10.5632667,9.4372 L13.9372667,9.4372 C14.5579333,9.4372 15.0619333,9.9412 15.0619333,10.5618667 L15.0619333,11.9992 Z M13.1252667,11.9992 L15.8762667,11.9992 C16.4969333,11.9992 17.0009333,12.5032 17.0009333,13.1238667 L17.0009333,15.8748667 C17.0009333,16.4978667 16.4969333,17.0018667 15.8762667,17.0018667 L13.1252667,17.0018667 C12.5046,17.0018667 12.0006,16.4978667 12.0006,15.8748667 L12.0006,13.1238667 C12.0006,12.5032 12.5046,11.9992 13.1252667,11.9992 L13.1252667,11.9992 Z M13.1252667,15.8748667 L15.8762667,15.8748667 L15.8762667,13.1238667 L13.1252667,13.1238667 L13.1252667,15.8748667 Z M4.12326667,11.9992 L6.87426667,11.9992 C7.49726667,11.9992 8.00126667,12.5032 8.00126667,13.1238667 L8.00126667,15.8748667 C8.00126667,16.4978667 7.49726667,17.0018667 6.87426667,17.0018667 L4.12326667,17.0018667 C3.5026,17.0018667 3.00093333,16.4978667 3.00093333,15.8748667 L3.00093333,13.1238667 C3.00093333,12.5032 3.5026,11.9992 4.12326667,11.9992 L4.12326667,11.9992 Z M4.12326667,15.8748667 L6.87426667,15.8748667 L6.87426667,13.1238667 L4.12326667,13.1238667 L4.12326667,15.8748667 Z M8.62426667,3.00186667 L11.3752667,3.00186667 C11.9959333,3.00186667 12.4999333,3.50353333 12.4999333,4.1242 L12.4999333,6.8752 C12.4999333,7.49586667 11.9959333,7.99986667 11.3752667,7.99986667 L8.62426667,7.99986667 C8.0036,7.99986667 7.4996,7.49586667 7.4996,6.8752 L7.4996,4.1242 C7.4996,3.50353333 8.0036,3.00186667 8.62426667,3.00186667 L8.62426667,3.00186667 Z M8.62426667,6.8752 L11.3752667,6.8752 L11.3752667,4.1242 L8.62426667,4.1242 L8.62426667,6.8752 Z",
  id: "Fill-1",
  fill: "#666666"
}))));

var SvgChannelManage = function SvgChannelManage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChannelManage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/channel_manage.af1466c5.svg";
export { ForwardRef as ReactComponent };